/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SubmittedJob } from './SubmittedJob';
import type { ThermalModelDetails } from './ThermalModelDetails';
/**
 * Inverter Loss Map ID.
 */
export type InverterLossMapID = {
    item_type?: InverterLossMapID.item_type;
    name?: string;
    mass?: number;
    moment_of_inertia?: number;
    cost?: number;
    _id?: string;
    data_id?: (string | null);
    submitted_job?: (SubmittedJob | null);
    thermal_model_details?: ThermalModelDetails;
    component_type?: 'InverterLossMapID';
    alternative_voltage_drop?: (number | null);
};
export namespace InverterLossMapID {
    export enum item_type {
        COMPONENT = 'component',
    }
}

